import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Slider from 'Components/ComponentLibrary/Atoms/Inputs/Slider';
import Typography from 'Components/UI/Typography';
import FormHelperText from '../../../Core/Form/FormHelperText';
import FormControl from '../../../Core/Form/FormControl';
import FormGroup from '../../../Core/Form/FormGroup';

const styles = (theme) => ({
  root: {},
  helperText: {},
  title: {
    marginBottom: theme.spacing(1.5),
  },
  slider: {
    marginTop: theme.spacing(3),
  },
});


function SliderPicklistControl({
  className,
  classes,
  error,
  helperText,
  testName,
  options,
  onChange,
  value,
  title,
  ...rest
}) {
  const min = React.useMemo(() => Math.min(...options.map(el => parseInt(el.value, 10))), [options]);
  const max = React.useMemo(() => Math.max(...options.map(el => parseInt(el.value, 10))), [options]);

  return (
    <FormControl
      error={error}
      className={classNames(classes.root, className)}
      {...rest}
    >
      <FormGroup
        test={`slider-picklist-control-${testName}`}
      >
        <Typography color="primary" className={classes.title}>
          {title}
        </Typography>
        <Slider
          className={classes.slider}
          onChange={onChange}
          value={value}
          min={min}
          max={max}
          color="primary"
          valueLabelDisplay="on"
          marks
        />
      </FormGroup>
      {helperText ? (
        <FormHelperText className={classes.helperText}>
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

SliderPicklistControl.defaultProps = {
  className: '',
};

SliderPicklistControl.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  testName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]).isRequired,
};

export default withStyles(styles, { name: 'SliderPicklistControl' })(SliderPicklistControl);
